
    export default {
        props: {
            pageSections: {
                type: Array,
                default: () => [],
            },
        },
    };
